import { NgModule } from '@angular/core';
import type { Route } from '@angular/router';
import { RouterModule } from '@angular/router';

import { ProductOrderComponent } from './product-order/product-order.component';
import { ProductOrderDefaultStep, ProductOrderStepUrl } from './product-order.types';
import { PlanPickerComponent } from '../../shared/plan-picker/plan-picker.component';

export const ROUTES: Route[] = [
  {
    path: '',
    component: ProductOrderComponent,
    children: [
      {
        path: ProductOrderStepUrl.ProductPicker,
        component: PlanPickerComponent,
      },
    ],
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: ProductOrderDefaultStep,
  },
];

@NgModule({
  imports: [RouterModule.forChild(ROUTES)],
})
export class ProductOrderRoutingModule {}
